import { getID } from "src/libs/utilities";
import { LANDING_TYPE_CONTENT } from "src/modules/pe-landing-module/data/interfaces";
import { components } from "src/modules/pe-landing-module/data/utils/components";

export default function createMeat(key: string, n: number = 0, data: any ={} ): any {
    
    console.log( key, n, components()[key]?.default )
    
    const meat:any =  {
        id: getID(key),
        type: components()[key] ? key : LANDING_TYPE_CONTENT.CANVAS,
        ...( 
            components()[key]?.default && components()[key].default.length >= 0
                ?  
                components()[key].default[ n ] 
                : 
                {} 
            )
    }
    return meat
}
